
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<NPSTooltip>({})
export default class NPSTooltip extends Vue {
    @Prop({ type: Number, default: 0 }) public width!: number
    @Prop({ type: String }) public color!: string

    get iconStyle() {
        let style = ''
        if (this.color) {
            style += `color: ${this.color}`
        }
        return style
    }
    get style() {
        let style = ''
        if (this.width) {
            style += `width: ${this.width}px;`
            style += `max-width: ${this.width}px;`
        }

        return style
    }
}
